// src/v3/currency/euro.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var CurrencyEuroIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "CurrencyEuroIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M19.527 16.07a6.964 6.964 0 0 1-5.522 2.68c-2.872 0-5.343-1.71-6.393-4.13h5.912c.41 0 .73-.34.73-.75s-.33-.75-.73-.75H7.172c-.06-.36-.1-.74-.1-1.12 0-.38.04-.75.1-1.12h6.352c.41 0 .73-.34.73-.75s-.33-.75-.73-.75H7.612c1.05-2.42 3.521-4.13 6.393-4.13a7.013 7.013 0 0 1 5.652 2.85c.24.33.71.41 1.04.16.33-.25.4-.71.16-1.05-1.58-2.17-4.141-3.46-6.852-3.46-3.712 0-6.863 2.36-7.984 5.63h-2.29c-.41 0-.731.34-.731.75s.33.75.73.75h1.931c-.05.37-.09.74-.09 1.12 0 .38.04.75.09 1.12h-1.93c-.41 0-.731.34-.731.75s.33.75.73.75h2.291c1.12 3.27 4.272 5.63 7.984 5.63 2.64 0 5.082-1.18 6.693-3.25.25-.33.2-.8-.13-1.05a.74.74 0 0 0-1.051.13l.01-.01Z"
  }
) });

export {
  CurrencyEuroIcon
};
